import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconForward20Style0 = cosmosIconCss;

const CosmosIconForward20$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconForward20 extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'd82b961e2bfaf8b24e50428bb89dd686aede4ee7', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ff1bf369b48a1baab0ba3bd4d8a626acd96b8f8b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8945f389d9a45d1418cc21e44aaba4dba929602d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14 6.472H9.372a5.11 5.11 0 0 0-5.162 4.817 4.852 4.852 0 0 0 1.362 3.565 5 5 0 0 0 2.841 1.493.51.51 0 0 0 .587-.5v-.532a.51.51 0 0 0-.425-.493c-.73-.137-1.4-.49-1.926-1.015a3.323 3.323 0 0 1-.939-2.473 3.6 3.6 0 0 1 3.662-3.358H14v2.3a.5.5 0 0 0 .854.352l3.032-3.052a.5.5 0 0 0 0-.706l-3.033-3.024A.5.5 0 0 0 14 4.2v2.272Zm.6 7.995V15.7a1.506 1.506 0 0 0 1.63 1.57 1.5 1.5 0 0 0 1.621-1.57v-1.229A1.505 1.505 0 0 0 16.23 12.9a1.506 1.506 0 0 0-1.63 1.567Zm2.051 1.209v-1.184c0-.35-.143-.532-.425-.532-.282 0-.431.188-.431.532v1.183c0 .344.143.531.431.531.288 0 .429-.182.429-.531l-.004.001Zm-2.532-1.424c0 .7-.38 1.02-1.1 1.48a5.41 5.41 0 0 0-.63.44h1.46a.278.278 0 0 1 .3.3v.42a.278.278 0 0 1-.3.3h-2.54a.278.278 0 0 1-.3-.3v-.14a2.016 2.016 0 0 1 1.15-1.64c.62-.4.75-.49.75-.73a.327.327 0 0 0-.35-.37.315.315 0 0 0-.33.24.3.3 0 0 1-.3.24h-.6a.268.268 0 0 1-.3-.32 1.45 1.45 0 0 1 1.59-1.28 1.323 1.323 0 0 1 1.5 1.36Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconForward20Style0; }
}, [1, "cosmos-icon-forward-20", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-forward-20"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-forward-20":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconForward20$1);
            }
            break;
    } });
}

const CosmosIconForward20 = CosmosIconForward20$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconForward20, defineCustomElement };
